import Card from "../../../../componentes/contenedores/Card";
import Page from "../../../../componentes/plantilla/Page";
import { useContextEmpleado } from "../../../../contexto/empleado/EmpleadoContext";
import TablaBuscarPromociones from "./TablaBuscarPromocion";

const HomeBuscarPromocion = () => {
    const { listaPromociones, setListaPromociones, ActualizarLista } = useContextEmpleado();
    const datos = {
        titulo: {
            titulo: "Busqueda promociones",
            url: "/app/admin/promociones/buscar",
            tituloUrl: "Menu Promociones",
            nombreUrl: "Inicio ",
        },
    };

    return (
        <Page datos={datos}>
            <Card>
                <TablaBuscarPromociones datos={listaPromociones}></TablaBuscarPromociones>
            </Card>
        </Page>
    );
}

export default HomeBuscarPromocion;